import styles from 'css/src/components/app/chat-tab/components/DevContextMenu.module.scss';

import React from 'react';
import classNames from 'classnames';

export interface DevContextMenuItem {
    label: string;
    onSelect: VoidFunction;
}

interface DevContextMenuProps {
    items: DevContextMenuItem[];
}

const DevContextMenu: React.FC<DevContextMenuProps> = ({ items }) => {
    const [open, setOpen] = React.useState(false);
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!open) {
            return undefined;
        }
        const handlePointerDown = (event: MouseEvent) => {
            if (!containerRef.current?.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);

    return (
        <div ref={containerRef} className="position-relative">
            <button
                type="button"
                aria-haspopup="menu"
                aria-expanded={open}
                className="btn btn-link p-l5-0 text-decoration-none color-grey-500"
                style={{ fontSize: 11 }}
                onClick={() => setOpen((prev) => !prev)}
            >
                context
            </button>
            {open && (
                <div
                    role="menu"
                    aria-label="context"
                    className={classNames(
                        styles['menu'],
                        'card position-absolute end-0 bottom-100 mb-l5-4 py-l5-4 d-flex flex-column',
                    )}
                >
                    {items.map((item) => (
                        <button
                            key={item.label}
                            type="button"
                            role="menuitem"
                            className={classNames(
                                styles['item'],
                                'btn btn-link text-decoration-none text-start color-grey-700 px-l5-12 py-l5-4',
                            )}
                            onClick={() => {
                                setOpen(false);
                                item.onSelect();
                            }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DevContextMenu;
